
<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="7" class="how_to_discover">
          <v-layout justify-center>
            <p>#サンゴ産卵の予感 の見つけ方</p>
          </v-layout>
          <v-layout justify-center>
            <video src="@/assets/how_movie.mp4" controls class="top-pc__how--movie"></video>
          </v-layout>
          <v-row justify="center" class="setting_image">
            <v-col cols="5">
                <v-img
                src="@/assets/setting_icon.png"
                ></v-img>
            </v-col>
            <v-col cols="5">
                <v-img
                src="@/assets/setting_image.png"
                ></v-img>
            </v-col>
          </v-row>
          <div class="top-pc__live--tweet-description text-center">
            突起の先の触手の部分に丸いタマゴが現れたら、産卵がはじまる合図。<br>
            「タマゴ発見！」ボタンを押してツイートすると、<br>
            アラートが鳴ってメンバーが駆けつけます！<br>
          </div>
          <div class="top-pc__live--tweet-attention text-center">
            ※ツイートしてからアラートが鳴るまで、最大30秒ほどラグが発生する可能性があります。<br>
            ※タマゴがないときは押さないでね！ <span class="top-pc__live--tweet-underline">絶対に、いたずらで押さないでね！</span> …絶対ダメだからね？
          </div>
          <div class="top-pc__live--tweet text-center">
              <p>#サンゴ産卵の予感 の発見に協力してくれた人たち</p>
              上のボタンを押してツイートしたらここに名前が掲載されるよ！
              <v-layout justify-center>
                <v-col cols="8" class="top-pc__live--tweet-list-content">
                  <div v-for="tweetInfo of tweetInfos" :key="tweetInfo.userName">
                    <TweetCell :tweet-info="tweetInfo"/>
                  </div>
                </v-col>
              </v-layout>
          </div>
      </v-col>
    </v-row>

    <!-- #ABOUT -->
    <div class="top-pc__about--spacer" id="about">
    </div>
    <v-row justify="center" class="top-pc__about">
        <v-col cols="7">
          <v-layout justify-center>
            <v-img
            class="top-pc__about-logo"
            src="@/assets/coralpj_logo.png"
            ></v-img>
          </v-layout>
          <p class="top-pc__about-text">
            遠い南国の海に広がる、美しいサンゴ礁。実はサンゴは、一年に一度だけ、初夏の満月の夜に一斉に産卵します。月明かりの元、満天の星空のように、新しい生命が降り注ぐ。多くのダイバーが毎年こぞって集まる、貴重で神秘的な光景です。
            <br><br>
            そんなサンゴ礁は今、地球温暖化や環境汚染の影響で、世界的に絶滅の危機にあります。多くの水生生物が住み、人間にも大きな恵みを与えてくれるサンゴ礁を未来に残すために。私たちは「東京サンゴ礁化計画」をスタートします。
            <br><br>
            東京の小さな水槽で、日本で初めてのサンゴの人工産卵を成功させ、奇跡の瞬間を都会の人々に届ける。それは、環境問題への関心を高めるだけでなく、サンゴの養殖技術の確立につながり、東京中でサンゴ礁保全の研究が行われるようになるかもしれません。さあ、一緒に地球の神秘を見守り、未来に希望を届けませんか？
          </p>
        </v-col>
    </v-row>


    <!-- #HOW TO WATCH -->
    <v-row justify="center" id="how">
        <v-col cols="7">
          <v-layout justify-center>
            <p class="top-pc__how--title-text">
              HOW TO WATCH
            </p>
          </v-layout>
          <v-layout justify-center>
            <p class="top-pc__how--sub-title-text">
              楽しみ方
            </p>
          </v-layout>
        </v-col>
        <v-col cols="7">
          <v-layout justify-center>
            <p class="top-pc__how--sub-title-text">
              <span class="top-pc__how--under-line">見守ろう！</span>
            </p>
          </v-layout>
        </v-col>
        <v-col cols="7">
          <v-layout justify-center>
            <v-img
              src="@/assets/how_image1.png"
            ></v-img>
          </v-layout>
        </v-col>
        <v-col cols="7">
          <v-layout justify-center>
            <p class="top-pc__how--description">
              遠い南国の海の底でしか見られないサンゴ産卵を、ライブ配信中！満月の夜から前後２週間程度の間、サンゴはいつ産卵してもおかしくありません。産卵する可能性があるのは、毎日19:00から24:00まで。奇跡の瞬間を見逃さないよう、ぜひ定期的に見に来てみてください。
            </p>
          </v-layout>
        </v-col>
        <v-col cols="7">
          <v-layout justify-center>
            <p class="top-pc__how--sub-title-text">
              <span class="top-pc__how--under-line">手伝おう！</span>
            </p>
          </v-layout>
        </v-col>
        <v-col cols="7">
          <v-layout justify-center>
            <v-img
              src="@/assets/how_image2.png"
            ></v-img>
          </v-layout>
        </v-col>
        <v-col cols="7">
          <v-layout>
            <p class="top-pc__how--description">
              サンゴは、産卵が始まる約1時間前、突起の先の触手の部分にピンク色の卵が浮き上がる「セッティング」という状態になります。これが、いよいよ産卵がはじまる合図。かすかな予兆を見逃さないために、ぜひみなさんの目をお借りできませんか？
            </p>
          </v-layout>
          <v-layout>
            <p class="top-pc__how--attention">
              ※一番はじめに発見された方には、何かお礼もできればと考えています。<br>
              ※ツイートしてからアラートが鳴るまで、最大30秒ほどラグが発生する可能性があります。
            </p>
          </v-layout>
          <v-layout>
            <p class="top-pc__live--tweet-attention">
              ※ツイートしてからアラートが鳴るまで、最大30秒ほどラグが発生する可能性があります。<br>
              ※タマゴがないときは押さないでね！ <span class="top-pc__live--tweet-underline">絶対に、いたずらで押さないでね！</span> …絶対ダメだからね？
            </p>
          </v-layout>
        </v-col>
        <v-col cols="7">
          <v-layout justify-center>
            <v-btn rounded color="#dd2037" dark class="top-pc__how--button" href="#live">∧ ライブ配信をチェックする</v-btn>
          </v-layout>
        </v-col>
    </v-row>

    <!-- #TECHNOLOGY -->
    <v-row justify="center" id="technology">
        <v-col cols="7">
          <v-layout justify-center>
            <p class="top-pc__tech--title-text">
              TECHNOLOGY
            </p>
          </v-layout>
          <v-layout justify-center>
            <p class="top-pc__tech--sub-title-text">
              水槽について
            </p>
          </v-layout>
        </v-col>
        <v-col cols="7">
          <v-layout justify-center>
            <v-img
            src="@/assets/tech_image1.png"
            ></v-img>
          </v-layout>
        </v-col>
        <v-col cols="7">
          <v-layout justify-center>
            <p class="top-pc__tech--sub-title-text">
              沖縄の海を、<span class="top-pc__tech--under-line">そのまま</span>再現した水槽
            </p>
          </v-layout>
          <v-layout justify-center>
            <p class="top-pc__tech--description">
              「東京サンゴ礁化計画」の水槽は、趣味で生態系を構築してきたアクアリストのノウハウと、IoT・AIなどのテクノロジーを組み合わせ、サンゴのふるさとである沖縄の海を都会に完全に再現したものです。従来のサンゴ研究は、天然の海水とサンゴを使うため海の近くでしかできませんでしたが、今回の産卵の成功によって場所を選ばずサンゴの基礎研究が進むようになり、サンゴ保全に大きく寄与することができると考えています。
            </p>
          </v-layout>
        </v-col>
        <v-col cols="7">
          <v-layout justify-center>
            <v-img
            src="@/assets/tech_image2.png"
            ></v-img>
          </v-layout>
        </v-col>
        <v-col cols="7">
          <v-layout justify-center>
            <p class="top-pc__tech--sub-title-text">
              サンゴだけではなく、<span class="top-pc__tech--under-line">生態系全体</span>を再現
            </p>
          </v-layout>
          <v-layout justify-center>
            <p class="top-pc__tech--description">
              水槽のなかには、数えられるだけでも40種類を超える水生生物が生息しています。それぞれの生体同士は「食べ・食べられ」、「住み・住まれ」、そして対立し合う複雑な関係にあり、人の手をほとんど加えなくても循環する生態系が構築されています。この自然に限りなく近い環境を私たちは「人工生態系」と定義し、環境教育や研究プラットフォームとしての活用を進めています。
            </p>
          </v-layout>
        </v-col>
        <v-col cols="7">
          <v-layout justify-center>
            <v-btn rounded color="#dd2037" dark class="top-pc__how--button" href="https://corp.innoqua.jp/">> 詳しくはこちら</v-btn>
          </v-layout>
        </v-col>
    </v-row>

    <!-- #TEAM -->
    <v-row justify="center" id="team">
        <v-col cols="7">
          <v-layout justify-center>
            <p class="top-pc__team--title-text">
              TEAM
            </p>
          </v-layout>
        </v-col>
        <v-col cols="7">
          <v-layout justify-center>
            <p class="top-pc__team--text">
              企画開発
            </p>
          </v-layout>
          <v-layout justify-center>
            <v-img
            class="top-pc__team--logo"
            src="@/assets/innoqua_logo.png"
            ></v-img>
          </v-layout>
        </v-col>
        <v-col cols="7">
          <v-layout justify-center>
            <p class="top-pc__team--text">
              映像・ライブ配信
            </p>
          </v-layout>
          <v-layout justify-center>
            <v-img
            class="top-pc__team--logo"
            src="@/assets/bascule_logo.png"
            ></v-img>
          </v-layout>
        </v-col>
    </v-row>

    <!-- #CONTACT -->
    <v-row justify="center" id="contact">
      <v-col cols="7">
        <v-layout justify-center>
          <v-btn
          href="https://prtimes.jp/main/html/rd/p/000000008.000047217.html"
          rounded
          color="#dd2037"
          dark
          class="top-pc__contact--button">
            プレスリリースはこちら
        </v-btn>
        </v-layout>
      </v-col>
        <v-col cols="7">
          <v-layout justify-center>
            <v-btn
            href="mailto:info@innoqua.jp"
            rounded
            color="#dd2037"
            dark
            class="top-pc__contact--button">
              CONTACT
          </v-btn>
          </v-layout>
        </v-col>
        <v-col class="main text-center" cols="12">2020 — ©︎Innoqua, Inc. ALL RIGHTS RESERVED.</v-col>
    </v-row>
  </v-container>
</template>

<script>
import TweetCell from '../TweetCell'

export default {
  name: 'TopDescription',
  data: () => ({
    tweetInfos : null,
    info: null,
    errored: false
  }), 
  mounted () {
    this.axios
      .get('https://6vvdzic3fh.execute-api.ap-northeast-1.amazonaws.com/prod/coralReadingTweet')
      .then(response => (
        this.tweetInfos = response.data
        ))
      .catch(error => {
        console.log(error)
        this.errored = true
      })
      .finally(() => this.loading = false)
  },
  components: {
    TweetCell
  },  
}
</script>

<style lang="scss" scoped>
.how_to_discover {
  padding: 2em 2em;
  margin: 2em 0;
  border: dashed 1px #F1FAEE;/*点線*/
}

.how_to_discover p {
  font-size: 1.8vw;
  font-weight: bold;
}

.setting_image {
  margin-top: 20px;
  margin-bottom: 20px;
}
.container {
  width: 100%;
  max-width: none;
  margin: 0px;
  padding: 0px;
}
// PC LIVE
.top-pc__live--title-text {
  font-size: 1.8vw;
  font-weight: bold;
  letter-spacing: 3px;
  text-align: center;
  margin-top: 100px;
}
.top-pc__live--title-text-attention {
  display: inline;
  vertical-align: top;
  font-size: 1vw;
  font-weight: bold;
  letter-spacing: 3px;
  text-align: center;
}
.top-pc__live--tweet {
  margin-top: 80px;
  border: 1px
}
.top-pc__live--under-line {
  border-bottom: solid;
  border-color: $color-accent;
  border-width: 5px;
  padding-bottom: 3px;
}
.top-pc__live--tweet-list-content {
  margin-top: 20px;
  height: 600px;
  overflow:auto;
}
.top-pc__live--youtube {
  margin-top: 16px;
  border: solid;
  border-color: #F1FAEE;
  border-width: 5px;
  width: 100%;
  height: 450px;
}
.top-pc__live--youtube-attention {
  font-size: 1vw;
  text-align: right;
}
.top-pc__live--sub-title-text {
  font-size: 1.5vw;
  font-weight: bold;
  letter-spacing: 3px;
  text-align: center;
  margin-top: 24px;
}
.top-pc__live--checking-text {
  font-size: 1.8vw;
  font-weight: bold;
  padding: 8px 16px 8px 16px;
  background-color: #E63946;
  text-align: center;
}
.top-pc__live--tweet-button {
  font-size: 2vw;
  font-weight: 800;
  color: #F1FAEE;
}
.top-pc__live--tweet-description {
  font-size: 1.2vw;
  line-height: 2em;
}
.top-pc__live--tweet-attention {
  font-size: 0.8vw;
  line-height: 2em;
}
.top-pc__live--tweet-underline {
  border-bottom: solid;
  border-color: $color-accent;
  border-width: 3px;
  padding-bottom: 3px;
}
// PC ABOUT
.row {
  margin-right:0px;
  margin-left: 0px;
}
.top-pc__about {
  margin-top: 48px;
  padding-top: 32px;
  padding-bottom: 32px;
  background: url("../../assets/coral_bg.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-color: rgba(29, 53, 87,0.6);
  background-blend-mode: darken;
}
.top-pc__about-logo {
  max-width: 500px;
}
.top-pc__about-text {
  font-size: 1.3vw;
  margin-top: 48px;
  line-height: 2em;
}
// PC HOW TO WATCH
.top-pc__how--title-text {
  font-size: 1.8vw;
  font-weight: bold;
  letter-spacing: 3px;
  margin-top: 48px;
  border: solid;
  border-color: #F1FAEE;
  border-width: 0px 5px 5px 5px;
  width: 320px;
  text-align: center;
  margin-bottom: 0px;
}
.top-pc__how--sub-title-text {
  font-size: 1.8vw;
  font-weight: bold;
  letter-spacing: 3px;
  text-align: center;
  margin-top: 32px;
}
.top-pc__how--under-line {
  border-bottom: solid;
  border-color: $color-accent;
  border-width: 5px;
  padding-bottom: 3px;
}
.top-pc__how--movie {
  border: solid;
  border-color: #F1FAEE;
  border-width: 5px;
  width: 100%;
}
.top-pc__how--description {
  font-size: 1.3vw;
  line-height: 2em;
}
.top-pc__how--attention {
  font-size: 0.8vw;
  line-height: 2em;
}
.top-pc__how--button {
  width: 480px;
  color: #F1FAEE;
}
// PC TECHNOLOGY
.top-pc__tech--title-text {
  font-size: 1.8vw;
  font-weight: bold;
  letter-spacing: 3px;
  margin-top: 150px;
  border: solid;
  border-color: #F1FAEE;
  border-width: 0px 5px 5px 5px;
  width: 320px;
  text-align: center;
  margin-bottom: 0px;
}
.top-pc__tech--sub-title-text {
  font-size: 1.8vw;
  font-weight: bold;
  letter-spacing: 3px;
  text-align: center;
  margin-bottom: 32px;
}
.top-pc__tech--under-line {
  border-bottom: solid;
  border-color: $color-accent;
  border-width: 5px;
  padding-bottom: 3px;
}
.top-pc__tech--description {
  font-size: 1.3vw;
  line-height: 2em;
}
// PC TEAM
.top-pc__team--title-text {
  font-size: 1.8vw;
  font-weight: bold;
  letter-spacing: 3px;
  margin-top: 150px;
  margin-bottom: 48px;
  border: solid;
  border-color: #F1FAEE;
  border-width: 0px 5px 5px 5px;
  width: 320px;
  text-align: center;
}
.top-pc__team--text {
  font-size: 1.3vw;
  line-height: 2em;
  margin-bottom: 0px;
}
.top-pc__team--logo {
  max-width: 270px;
  margin-bottom: 48px;
}
// PC CONTACT
.top-pc__contact--button {
  width: 480px;
}
</style>
